import Text from '../Base/Text/Text';

export default function LekovyZaznamListItem(props) {
	const { title } = props;

	return (
		<div className='erecept-list__item'>
			<div className='erecept-list__item__medicament bordered'>
				<div>
					<div className='erecept-list__item__medicament__title d-flex justify-content-between' />
				</div>
			</div>
		</div>
	);
}
